import { Routes, Route } from "react-router-dom";

import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.css";
import Login from "./Components/Login";
import Signup from "./Components/popup/Signup";
import Blogs from "./Components/Blogs";
import ManageWebinars from "./Components/Webinars";
import News from "./Components/News";
import Job from "./pages/JobPage";
import Layout from "./Components/Layout/Layout";
import TestEditior from "./Components/TestEditior";
import NewsFormPage from "./Components/NewsForm/NewsForm";
import HTMLEditor from "./Components/HtmlEditior/HTMLEditor";

function App() {
  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
      />

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route element={<Layout />}>
          {/* <Route path="/home" element={<Home />} /> */}
          <Route path="/Blogs" element={<Blogs />} />
          <Route path="/Webinars" element={<ManageWebinars />} />
          <Route path="/News" element={<News />} />
          <Route path="/Jobs" element={<Job />} />
          <Route path="/editior" element={<TestEditior />} />
          <Route path="/newsform" element={<NewsFormPage />} />
          <Route path="/newsform/:id" element={<NewsFormPage />} />
          <Route path="/HTMLEditor" element={<HTMLEditor />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
